/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import { defineComponent } from '@vue/composition-api';
import { MirrorIcon, RotationIcon, ZoomOutIcon, ZoomInIcon, ImageIcon, DownloadIcon } from 'tdesign-icons-vue';
import TImageViewerIcon from './ImageModalIcon.js';
import { Tooltip } from '../../tooltip/index.js';
import { usePrefixClass } from '../../hooks/useConfig.js';
import { downloadFile } from '../utils.js';
import '@babel/runtime/helpers/defineProperty';
import '../../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../hooks/render-tnode.js';
import 'lodash/isString';
import 'lodash/isObject';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../../tooltip/tooltip.js';
import '../../_chunks/dep-9d6f3de6.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@babel/runtime/helpers/typeof';
import '@popperjs/core';
import '../../utils/dom.js';
import 'vue';
import 'raf';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import '../../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../../_common/js/utils/set-style.js';
import '../../popup/container.js';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/map-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../tooltip/type.js';

var currentImage = {
  type: Object,
  "default": function _default() {
    return {};
  }
};
var TImageViewerUtils = defineComponent({
  name: "TImageViewerUtils",
  props: {
    scale: Number,
    rotateHandler: Function,
    zoomInHandler: Function,
    zoomOutHandler: Function,
    mirrorHandler: Function,
    resetHandler: Function,
    currentImage: currentImage
  },
  setup: function setup() {
    var classPrefix = usePrefixClass();
    return {
      classPrefix: classPrefix
    };
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__utils")
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__utils-content")
    }, [h(Tooltip, {
      "attrs": {
        "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
        "content": "\u955C\u50CF",
        "destroyOnClose": true,
        "placement": "top",
        "showArrow": true,
        "theme": "default"
      }
    }, [h(TImageViewerIcon, {
      "attrs": {
        "clickHandler": this.mirrorHandler,
        "icon": function icon() {
          return h(MirrorIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        }
      }
    })]), h(Tooltip, {
      "attrs": {
        "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
        "content": "\u65CB\u8F6C",
        "destroyOnClose": true,
        "placement": "top",
        "showArrow": true,
        "theme": "default"
      }
    }, [h(TImageViewerIcon, {
      "attrs": {
        "clickHandler": this.rotateHandler,
        "icon": function icon() {
          return h(RotationIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        }
      }
    })]), h(TImageViewerIcon, {
      "attrs": {
        "icon": function icon() {
          return h(ZoomOutIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        },
        "clickHandler": this.zoomOutHandler
      }
    }), h(TImageViewerIcon, {
      "class": "".concat(this.classPrefix, "-image-viewer__utils-scale"),
      "attrs": {
        "size": "medium",
        "label": "".concat(this.scale * 100, "%")
      }
    }), h(TImageViewerIcon, {
      "attrs": {
        "icon": function icon() {
          return h(ZoomInIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        },
        "clickHandler": this.zoomInHandler
      }
    }), h(Tooltip, {
      "attrs": {
        "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
        "content": "\u539F\u59CB\u5927\u5C0F",
        "destroyOnClose": true,
        "placement": "top",
        "showArrow": true,
        "theme": "default"
      }
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer__modal-icon")
    }, [h(TImageViewerIcon, {
      "attrs": {
        "icon": function icon() {
          return h(ImageIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        },
        "clickHandler": this.resetHandler
      }
    })])]), this.currentImage.download && h(TImageViewerIcon, {
      "attrs": {
        "icon": function icon() {
          return h(DownloadIcon, {
            "attrs": {
              "size": "medium"
            }
          });
        },
        "clickHandler": function clickHandler() {
          downloadFile(_this.currentImage.mainImage);
        }
      }
    })])]);
  }
});

export { TImageViewerUtils as default };
//# sourceMappingURL=ImageViewerUtils.js.map
